import { FormEvent, FunctionComponent, ReactElement } from 'react';
import {
	Dialog as MuiDialog,
	DialogTitle as MuiDialogTitle,
	DialogActions as MuiDialogActions,
	DialogContent as MuiDialogContent,
	DialogContentText as MuiDialogContentText,
	Button,
	Box,
} from '@mui/material';
import useErrors from '@/shared/context/errors-context';
import LoadingButton from '../loading-button';
import { FormDialogProps } from './types';

const FormDialog: FunctionComponent<FormDialogProps> = ({
	formKey,
	maxWidth = 'xs',
	fullWidth,
	title,
	description,
	open,
	onClose,
	children,
	actions,
	onSubmit,
	className,
	...rest
}): ReactElement => {
	const { clear: clearErrors } = useErrors();

	const handleSubmit = (event: FormEvent) => {
		event.preventDefault();
		onSubmit();
	};

	const handleClose = () => {
		if (formKey) clearErrors(formKey);
		onClose();
	};

	return (
		<MuiDialog
			open={open}
			onClose={handleClose}
			fullWidth={fullWidth}
			maxWidth={maxWidth}
			{...rest}
		>
			<MuiDialogTitle>{title}</MuiDialogTitle>
			<Box component="form" onSubmit={handleSubmit} className={className}>
				<MuiDialogContent>
					{description && <MuiDialogContentText>{description}</MuiDialogContentText>}
					{children}
				</MuiDialogContent>
				<MuiDialogActions>
					<Button onClick={handleClose}>{actions.cancel.label}</Button>
					<LoadingButton
						loading={actions.confirm.isLoading}
						disabled={actions.confirm.disabled}
						variant="contained"
						type="submit"
					>
						{actions.confirm.label}
					</LoadingButton>
				</MuiDialogActions>
			</Box>
		</MuiDialog>
	);
};

export default FormDialog;
